import isEqual from "fast-deep-equal/es6";
import { create } from "zustand";
import { OmgevingService } from "../services/omgevingService";
import { FetchState } from "./util";

// De velden hieronder zijn de sleutels van de opgeslagen omgevingssamenvatting
// (`summarize_omgeving` in de backend) en blijven daarom Nederlands.

/** `url` om te lezen, `kaartUrl` voor Regels op de kaart; van de monitor (#79). */
type PublicLinks = { url?: string | null; kaartUrl?: string | null };

export type Regulation = PublicLinks & {
  titel: string;
  soort: string | null;
  bestuurslaag: string;
  artikelen: number;
};

export type OmgevingDocument = PublicLinks & { titel: string; soort: string | null };

export type Analysis = {
  analyse: string;
  regeling?: string;
  artikel: string | string[];
  resultaat: Record<string, unknown>;
  url?: string | null;
};

export type Plan = PublicLinks & {
  naam: string;
  soort: string | null;
  status: string;
  aanduidingen: string[];
  gebiedsaanduidingen: string[];
  maatvoeringen: string[];
  analyses: Analysis[];
};

/** De samenvatting die `POST /api/omgeving` levert; leeg bij een storing. */
export type Omgeving = {
  raadpleegDatum?: string;
  regelingen?: Regulation[];
  documenten?: OmgevingDocument[];
  analyses?: Analysis[];
  imro?: { plannen: Plan[] };
};

interface OmgevingState {
  state?: FetchState;
  geometry?: GeoJSON.Geometry;
  omgeving?: Omgeving;
  load: (geometry: GeoJSON.Geometry) => void;
}

/**
 * Zelfde vorm als de publicatiesstore, maar niemand roept `load` bij het
 * renderen aan: pas het uitklappen doet dat. Een vers gebied kost de monitor
 * tientallen DSO-calls en tot 90 seconden, en een snelle klik over de kaart
 * hoort dat niet uit te lokken.
 */
export const useOmgeving = create<OmgevingState>((set, get) => ({
  load: async (geometry: GeoJSON.Geometry) => {
    const cur = get();
    if (isEqual(cur.geometry, geometry) && cur.state !== "error") return;
    set({ geometry, state: "fetching", omgeving: undefined });
    try {
      const omgeving = await OmgevingService.omgeving(geometry);
      if (isEqual(get().geometry, geometry)) set({ state: "fetched", omgeving });
    } catch {
      if (isEqual(get().geometry, geometry)) set({ state: "error" });
    }
  },
}));
